export default "__VITE_ASSET__2de5855b__"